export const biPattern = /^PerformanceMetrics\//;
export const phoneBiPattern = /^PhonePerformanceMetrics\//;
export const poPPattern = /^PoP(Phone)?PerformanceMetrics/;
export const customColumnPattern = /^CustomColumn/;
export const competitiveAttributes = [
  'PerformanceMetricsAuctionWonPercent',
  'PerformanceMetricsAuctionLostToBudgetPercent',
  'PerformanceMetricsAuctionLostToRankPercent',
  'PerformanceMetricsAuctionLostToRankAggPercent',
  'PerformanceMetricsAuctionLostToAdQualityPercent',
  'PerformanceMetricsAuctionLostToLandingPercent',
  'PerformanceMetricsAuctionLostToBidPercent',
  'PerformanceMetricsExactMatchImpressionSharePercent',
  'PerformanceMetricsTopImpressionSharePercent',
  'PerformanceMetricsTopISLostToBudgetPercent',
  'PerformanceMetricsTopISLostToRankPercent',
  'PerformanceMetricsAbsoluteTopImpressionSharePercent',
  'PerformanceMetricsAbsoluteTopISLostToBudgetPercent',
  'PerformanceMetricsAbsoluteTopISLostToRankPercent',
  'PerformanceMetricsClickSharePercent',
  'PerformanceMetricsAudienceAuctionWonPercent',
  'PerformanceMetricsAudienceTopISLostToBudgetPercent',
  'PerformanceMetricsAudienceTopISLostToRankPercent',
  'PerformanceMetricsRelativeCTR',
];
export const conversionAttributes = [
  'PerformanceMetricsCPA',
  'PerformanceMetricsPartialConversionCPA',
  'PerformanceMetricsConversions',
  'PerformanceMetricsConversionsCredit',
  'PerformanceMetricsConversionRate',
  'PerformanceMetricsPartialConversionRate',
  'PerformanceMetricsAdvertiserReportedRevenue',
  'PerformanceMetricsAdvertiserReportedRevenueAdjustment',
  'PerformanceMetricsRevenueOnAdSpend',
  'PerformanceMetricsAllConversionCPA',
  'PerformanceMetricsAllPartialConversionCPA',
  'PerformanceMetricsAllConversions',
  'PerformanceMetricsAllConversionsCredit',
  'PerformanceMetricsAllConversionRate',
  'PerformanceMetricsAllPartialConversionRate',
  'PerformanceMetricsAllConversionAdvertiserReportedRevenue',
  'PerformanceMetricsAllConversionAdvertiserReportedRevenueAdjustment',
  'PerformanceMetricsAllConversionRevenueOnAdSpend',
  'PerformanceMetricsViewThroughConversions',
  'PerformanceMetricsViewThroughConversionsCredit',
  'PerformanceMetricsViewThroughConversionsRevenue',
  'PerformanceMetricsViewThroughConversionsRevenueAdjustment',
  'PerformanceMetricsViewThroughConversionsCPA',
  'PerformanceMetricsViewThroughPartialConversionsCPA',
  'PerformanceMetricsViewThroughConversionsReturnOnAdSpend',
  'PerformanceMetricsViewThroughConversionsRate',
  'PerformanceMetricsViewThroughPartialConversionsRate',
  'PerformanceMetricsQuantityBought',
  'PerformanceMetricsInstalls',
  'PerformanceMetricsCostPerInstall',
  'PerformanceMetricsRevenuePerInstall',
  'PerformanceMetricsSalesCount',
];
